import { assignRef } from './assignRef';
import { createCallbackRef } from './createRef';
/**
 * Transforms one ref to another
 * @example
 * ```tsx
 * const ResizableWithRef = forwardRef((props, ref) =>
 *   <Resizable {...props} ref={transformRef(ref, i => i ? i.resizable : null)}/>
 * );
 * ```
 */
export function transformRef(ref, transformer) {
    return createCallbackRef(function (value) { return assignRef(ref, transformer(value)); });
}



//////////////////
// WEBPACK FOOTER
// ./~/use-callback-ref/dist/es2015/transformRef.js
// module id = 9161
// module chunks = 2